"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var castDateToISO_1 = __importDefault(require("./castDateToISO"));
var getMonthDiff_1 = __importDefault(require("./getMonthDiff"));
var getMonthsToShow_1 = __importDefault(require("./getMonthsToShow"));
var changeMonth_1 = __importDefault(require("./changeMonth"));
var constants_1 = require("./constants");
var getBaseDate = function (_a) {
    var baseDate = _a.baseDate, vertical = _a.vertical, minDate = _a.minDate, maxDate = _a.maxDate, monthsToShow = _a.monthsToShow;
    var today = new Date();
    var isoToday = (0, castDateToISO_1.default)(new Date());
    var baseMonthDate = baseDate || new Date(today.getFullYear(), today.getMonth(), 1);
    var isoBaseMonthDate = (0, castDateToISO_1.default)(baseMonthDate);
    var isoMinDate = minDate && (0, castDateToISO_1.default)(minDate);
    var isoMaxDate = maxDate && (0, castDateToISO_1.default)(maxDate);
    var diff = 0;
    if (!baseDate && minDate && isoMinDate && isoBaseMonthDate < isoMinDate) {
        diff = (0, getMonthDiff_1.default)(baseMonthDate, minDate);
    }
    if (!baseDate && maxDate && isoMaxDate && isoBaseMonthDate > isoMaxDate) {
        diff = (0, getMonthDiff_1.default)(baseMonthDate, maxDate);
        // Show the max date as the last month in multi month mode
        diff = diff - (0, getMonthsToShow_1.default)({ vertical: vertical, monthsToShow: monthsToShow }) + 1;
    }
    if (!baseDate &&
        minDate &&
        isoMinDate &&
        isoMaxDate &&
        isoToday > isoMaxDate) {
        diff = (0, getMonthDiff_1.default)(today, minDate);
    }
    if (diff && (minDate || maxDate)) {
        return {
            date: (0, changeMonth_1.default)(baseMonthDate, diff),
            diff: diff,
        };
    }
    if (!vertical) {
        return {
            date: baseMonthDate,
            diff: diff,
        };
    }
    diff = -constants_1.VERTICAL_MONTHS_THRESHOLD;
    return {
        date: (0, changeMonth_1.default)(baseMonthDate, diff),
        diff: diff,
    };
};
exports.default = getBaseDate;
